import React, { Component, Fragment } from "react";

export default class PageEducacao extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            user: {},
            unidades: [ 
                {
                    nome: "Painel",
                    link: "/dashboard"
                },
                {
                    nome: "Unidades",
                    link: "/unidade"
                },
                {
                    nome: "Dashboard Consolidado",
                    link: "/dashboardconsolidado"
                },
                {
                    nome: "Produção",
                    link: "/producaoep"
                }
            ]
        }
    }

    render() {
        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="places-buttons">
                                        <div className="row">
                                            <div className="col-md-6 ml-auto mr-auto text-center">
                                                <h4 className="card-title"> Unidades
                                                    <p className="category">Escolha uma unidade</p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 ml-auto mr-auto">
                                                <div className="row">
                                                    {this.state.unidades.map((unidade, key) => {
                                                        return (
                                                            <div key={key} className="col-md-3">
                                                                <a href={unidade.link}>
                                                                    <button type="button" className="btn btn-primary btn-block">{unidade.nome}</button>
                                                                </a>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}